import type {FC} from 'react';
import {Link} from 'react-router-dom';
import {Box, Tab, Tabs} from '@wellstone-solutions/web';
import {Theme} from '@wellstone-solutions/common';
import {ActiveCount} from 'components/ActiveCount';
import type {TabbedPageTab} from './types';

type Props = {
  tabs: TabbedPageTab[];
  activeTab: TabbedPageTab;
  ariaLabel: string;
};

export const TabBar: FC<Props> = ({tabs, activeTab, ariaLabel}) => (
  <Box sx={styles.tabsContainer}>
    <Tabs
      value={activeTab.path}
      variant="scrollable"
      scrollButtons="auto"
      sx={styles.tabs}
      aria-label={ariaLabel}>
      {tabs.map(({path, label, count}) => (
        <Tab
          key={path}
          value={path}
          component={Link}
          to={path}
          label={
            count == null ? (
              label
            ) : (
              <span style={styles.tabLabel}>
                {label}
                <ActiveCount
                  count={count}
                  sx={{
                    ...styles.badge,
                    backgroundColor:
                      path === activeTab.path
                        ? Theme.colorPalette.secondary
                        : Theme.colorPalette.primary,
                  }}
                />
              </span>
            )
          }
        />
      ))}
    </Tabs>
  </Box>
);

const styles = {
  tabsContainer: {
    borderBottom: 1,
    borderColor: 'divider',
    mb: 2,
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  badge: {
    width: 22,
    height: 22,
    borderRadius: '50%',
    fontSize: 12,
    '& .MuiChip-label': {
      padding: 0,
    },
  },
  tabs: {
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: Theme.typography.size.s3,
      color: Theme.colorPalette.primary,
      '&.Mui-selected': {
        color: Theme.colorPalette.secondary,
      },
    },
    '& .MuiTabs-indicator': {
      backgroundColor: Theme.colorPalette.secondary,
    },
  },
};
